<template>
    <div id="Profile" style="padding-left: 16px;padding-right: 16px">
        <q-dialog @before-hide="resetImage" position="right" v-model="profileDialog">
            <q-card>
                <div class="row">
                    <div class="col-12">
                        <vue-cropper :src="imgSrc2?imgSrc2:tempImage" alt="Source Image"
                                     class="p-b-10"
                                     ref="cropper">
                        </vue-cropper>
                        <img :src="imgSrc2" aspect-ratio="1" contain style="margin-bottom: 10px"
                             v-if="!imgSrc"/>
                        <input @change="setImage" accept="image/*" id="file" style="display: none" type="file">
                        <q-btn @click="clickFile()" class="bm-profile-button-light m-0">Select Image</q-btn>
                        <q-btn @click="uploadImage()" class="bm-profile-button-light m-0">Upload Image</q-btn>
                    </div>
                </div>
            </q-card>
        </q-dialog>
        <LightGallery :disable-scroll="true" :images="fullScreenImageArr" :index="imageIndex"
                      @close="fullScreenImageDialog=false" v-if="fullScreenImageDialog"></LightGallery>
        <div class="row q-pa-md">
            <div class="col-4 py-3 ">
                <div class="p-box">
                    <div class="d-flex justify-content-between mb-3 p-info">
                        <h6>Company Info</h6>
                    </div>
                    <div class="mx-auto d-block w-100">
                        <template v-if="imgSrc2">
                            <img :src="imgSrc2" alt="" class="w-100" style="height: 150px">
                        </template>
                        <template v-else>
                            <avatar :size="90" :username="profile.name" class="mx-auto"/>
                        </template>
<!--                        <i @click="resetImage" class="fas fa-edit" style="font-size: 18px; font-weight: 300"></i>-->
<!--                        <i @click="removeImage" class="fas fa-edit" style="font-size: 18px; font-weight: 300"></i>-->
                    </div>
                    <h5 class="partner-name ">{{profile?profile.name:'-'}}</h5>
                    <span style="display: block; text-align: center; color: #000; font-size: 14px">{{profile?profile.partnerCode:'-'}}</span>
                    <div class="p-type mx-auto">
                        <h6>{{profile.PartnerType?profile.PartnerType.name:'-'}}</h6>
                    </div>

                    <div class="mt-5">

                        <ul class="p-3" style="list-style: none">
                            <li>
                                <div class="d-flex">
                                    <div class="p-icon">
                                            <span>
                                                <i class="material-icons">local_phone</i>
                                            </span>
                                    </div>
                                    <div class="p-text ml-4">
                                        <span>{{profile.alternateNumber?profile.alternateNumber:'-'}}</span>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div class="d-flex">
                                    <div class="p-icon">
                                            <span>
                                                <i class="material-icons">email</i>
                                            </span>
                                    </div>
                                    <div class="p-text ml-4">
                                        <span>{{profile.email?toLower(profile.email):'-'}}</span>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div class="d-flex">
                                    <div class="p-icon">
                                            <span>
                                                <i class="material-icons">room</i>
                                            </span>
                                    </div>
                                    <div class="p-text ml-4">
                                            <span class="d-block " v-if="profile.address">{{profile.address.add1|titleize}},
                        {{profile.address.add2|titleize}}, {{profile.address.area|titleize}}, {{profile.address.city|titleize}}, {{profile.address.state|titleize}}, {{profile.address.country|titleize}}, {{profile.address.pin|titleize}}</span>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div class="d-flex">
                                    <div class="p-icon">
                                            <span>
                                                <i class="material-icons">calendar_today</i>
                                            </span>
                                    </div>
                                    <div class="p-text ml-4">
                                        <span>{{profile?dateFilter(profile.incorporateDate):'-'}}</span>
                                    </div>
                                </div>
                            </li>
                            <!--<li>-->
                            <!--<div class="d-flex">-->
                            <!--<div class="p-icon">-->
                            <!--<span>-->
                            <!--<i class="material-icons">-->
                            <!--favorite-->
                            <!--</i>-->
                            <!--</span>-->
                            <!--</div>-->
                            <!--<div class="p-text">-->
                            <!--<span>24 / 11 / 2019</span>-->
                            <!--</div>-->
                            <!--</div>-->
                            <!--</li>-->
                        </ul>
                    </div>

                    <q-btn @click="openUpdatePasswordDialog()" class="pd-btn  my-3">Update Password</q-btn>
                </div>
            </div>
            <div class="col-4">
                <div class="row q-pa-md" v-if="profile && user">

                    <!--user image-->


                    <!--user details-->
                    <div class="col-12 pb-3 ">

                        <div class="p-box overflow-hidden">
                            <div class="d-flex justify-content-between mb-3 p-info">
                                <!-- <h6>Visiting card</h6> -->
                                <h6>Certificate</h6>
                                <!--                                <h5><i class="material-icons">-->
                                <!--                                    more_vert-->
                                <!--                                </i></h5>-->
                            </div>

                            <div @click="viewImage(visitingCardUrl, 0)" style="cursor: pointer">
                                <!--<a :href="visitingCardUrl" download="AwesomeImage.png">-->
                                <img :src="visitingCardUrl" class="w-100">
                                <!--</a>-->
                            </div>
                        </div>
                    </div>

                    <div class="col-12 pt-3 ">
                        <div class="p-box">
                            <div class="d-flex justify-content-between mb-3 p-info">
                                <h6>Partner Info</h6>
                                <!--                                <h5><i class="material-icons">-->
                                <!--                                    more_vert-->
                                <!--                                </i></h5>-->
                            </div>

                            <ul class="p-3" style="list-style: none">
                                <li>
                                    <div class="d-flex">
                                        <div class="p-icon">
                                            <span>
                                                <i class="fas fa-user"></i>
                                            </span>
                                        </div>
                                        <div class="p-text ml-4">
                                            <span>{{user&&user.name?user.name:'-'}}</span>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div class="d-flex">
                                        <div class="p-icon">
                                            <span>
                                                <i class="material-icons">local_phone</i>
                                            </span>
                                        </div>
                                        <div class="p-text ml-4">
                                            <span>{{user?user.mobile:'-'}}</span>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div class="d-flex">
                                        <div class="p-icon">
                                            <span>
                                                <i class="material-icons">email</i>
                                            </span>
                                        </div>
                                        <div class="p-text ml-4">
                                            <span>{{user.email?toLower(user.email):'-'}}</span>
                                        </div>
                                    </div>
                                </li>
                                <!--<li>-->
                                <!--<div class="d-flex">-->
                                <!--<div class="p-icon">-->
                                <!--<span>-->
                                <!--<i class="material-icons">smartphone</i>-->
                                <!--</span>-->
                                <!--</div>-->
                                <!--<div class="p-text">-->
                                <!--<span>{{user.alternateNumber}}</span>-->
                                <!--</div>-->
                                <!--</div>-->
                                <!--</li>-->
                                <li>
                                    <div class="d-flex">
                                        <div class="p-icon">
                                            <span>
                                                <i class="material-icons">cake</i>
                                            </span>
                                        </div>
                                        <div class="p-text ml-4">
                                            <span>{{user.birthdate?dateFilter(user.birthdate):'-'}}</span>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div class="d-flex">
                                        <div class="p-icon">
                                            <span>
                                                <i class="material-icons">favorite</i>
                                            </span>
                                        </div>
                                        <div class="p-text ml-4">
                                            <span>{{user.aniversary?dateFilter(user.aniversary):'-'}}</span>

                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="row q-pa-md">

                    <div class="col-12 py-3 ">
                        <div v-if="profile.PartnerType&&profile.PartnerType.name">
                            <!--      <div class="preffer-box d-block p-3 mb-4"
                                       v-if="profile.PartnerType.name==='VALUE ADDED DISTRIBUTOR'||profile.PartnerType.name==='VALUE ADDED PARTNER'">
                                      <div class="d-flex justify-content-between mb-3 p-info">
                                          <h6>Sales Executive</h6>
                                      </div>
                                      <div class="d-flex">
                                          <div class="preffer-icon my-auto">
                                              <img alt="" class="w-100" src="../../assets/user1.png">
                                          </div>
                                          <div class="preffer-info">
                                              <ul style="list-style: none">
                                                  <li>
                                                      <div>
                                                          <h6 class="mb-2"
                                                              style="font-weight: 400; text-transform: capitalize">
                                                              {{profile.SalesPersonId?profile.SalesPersonId.name:'-'}}</h6>
                                                      </div>
                                                  </li>
                                                  <li>
                                                      <div class="d-flex">
                                                          <div class="p-icon">
                                                              <i class="material-icons">local_phone</i>
                                                          </div>
                                                          <div class="p-text ml-4">
                                                              <span>{{profile.SalesPersonId?profile.SalesPersonId.mobile:'-'}}</span>
                                                          </div>
                                                      </div>
                                                  </li>
                                                  <li>
                                                      <div class="d-flex">
                                                          <div class="p-icon">
                                                              <i class="material-icons">email</i>
                                                          </div>
                                                          <div class="p-text ml-4">
                                                              {{profile.SalesPersonId?toLower(profile.SalesPersonId.email):'-'}}
                                                          </div>
                                                      </div>
                                                  </li>
                                              </ul>
                                          </div>
                                      </div>
                                  </div>                             -->
                            <div class="preffer-box d-block p-3 mb-4"
                                 v-if="profile.partnerType === Constants.VAD||profile.partnerType === Constants.VAP||profile.partnerType === Constants.RP">
                                <div class="d-flex justify-content-between mb-3 p-info">
                                    <h6>Sales Executives</h6>
                                    <!--                                    <h5><i class="material-icons">-->
                                    <!--                                        more_vert-->
                                    <!--                                    </i></h5>-->
                                </div>
                                <div class="d-flex" v-for="sp in profile.SalesPersons"  v-if="sp.SalesPerson">
                                    <div class="preffer-icon my-auto">
                                        <img alt="" class="w-100" src="../../assets/user1.png">
                                    </div>
                                    <div class="preffer-info">
                                        <ul style="list-style: none">
                                            <li>
                                                <div>
                                                    <h6 class="mb-2"
                                                        style="font-weight: 400; text-transform: capitalize">
                                                        {{sp.SalesPerson.name?sp.SalesPerson.name:'-'}}</h6>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="d-flex">
                                                    <div class="p-icon">
                                                        <i class="material-icons">local_phone</i>
                                                    </div>
                                                    <div class="p-text ml-4">
                                                        <span>{{sp.SalesPerson.mobile?sp.SalesPerson.mobile:'-'}}</span>
                                                    </div>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="d-flex">
                                                    <div class="p-icon">
                                                        <i class="material-icons">email</i>
                                                    </div>
                                                    <div class="p-text ml-4">
                                                        {{sp.SalesPerson.email?(toLower(sp.SalesPerson.email)):'-'}}
                                                    </div>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                    <!--                                <div class="preffer-person">-->
                                    <!--                                    VAP-->
                                    <!--                                </div>-->
                                </div>

                                <div class="d-flex " style="background: #fff;"
                                     v-if="profile.SalesPersons && profile.SalesPersons.length==0">
                                    <div class="preffer-icon my-auto">
                                        <img alt="" class="w-100" src="../../assets/user1.png">
                                    </div>
                                    <div class="preffer-info">
                                        <ul>
                                            <!--<img alt="" src="../../../src/assets/error.png" style="width: 100%">-->
                                            <span style="font-size: 16px; text-align: center; display: block">No Sales Executive</span>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="preffer-box d-block p-3 mb-4"
                                 v-if="profile.PartnerType.name!=='VALUE ADDED DISTRIBUTOR'">
                                <div class="d-flex justify-content-between mb-3 p-info">
                                    <h6>Referral VAP </h6>
                                    <!--                                    <h5><i class="material-icons">-->
                                    <!--                                        more_vert-->
                                    <!--                                    </i></h5>-->
                                </div>
                                <div class="d-flex">
                                    <div class="preffer-icon my-auto">
                                        <img alt="" class="w-100" src="../../assets/user2.png">
                                    </div>
                                    <div class="preffer-info">
                                        <ul style="list-style: none">
                                            <li>
                                                <div>
                                                    <h6 class="mb-2"
                                                        style="font-weight: 400; text-transform: capitalize">
                                                        {{profile.ParentPartner?profile.ParentPartner.name:'-'}}</h6>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="d-flex">
                                                    <div class="p-icon">
                                                        <i class="material-icons">local_phone</i>
                                                    </div>
                                                    <div class="p-text ml-4">
                                                        <span>{{profile.ParentPartner?profile.ParentPartner.mobile:'-'}}</span>
                                                    </div>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="d-flex">
                                                    <div class="p-icon">
                                                        <i class="material-icons">email</i>
                                                    </div>
                                                    <div class="p-text ml-4">
                                                        {{profile.ParentPartner?toLower(profile.ParentPartner.email):'-'}}
                                                    </div>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                    <!--                                <div class="preffer-person">-->
                                    <!--                                    ref-->
                                    <!--                                </div>-->
                                </div>
                            </div>
                            <!--<div v-if="profile.PartnerType.name!=='VALUE ADDED DISTRIBUTOR'" class="preffer-box d-block p-3 ">-->
                            <div class="preffer-box d-block p-3 ">
                                <div class="d-flex justify-content-between mb-3 p-info">
                                    <h6>Preferred Distributors for Purchase</h6>
                                    <!--                                    <h5><i class="material-icons">-->
                                    <!--                                        more_vert-->
                                    <!--                                    </i></h5>-->
                                </div>
                                <div class="d-flex" v-for="distributor in preferredDistributorsList">
                                    <div class="preffer-icon my-auto">
                                        <img alt="" class="w-100" src="../../assets/user3.png">
                                    </div>
                                    <div class="preffer-info overflow-hidden">
                                        <ul style="list-style: none">
                                            <li>
                                                <div>
                                                    <h6 class="mb-2"
                                                        style="font-weight: 400; text-transform: capitalize">
                                                        {{distributor.PrefferedPartner?distributor.PrefferedPartner.name:'-'}}</h6>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="d-flex">
                                                    <div class="p-icon">
                                                        <i class="material-icons">local_phone</i>
                                                    </div>
                                                    <div class="p-text ml-4">
                                                        <span>{{distributor.PrefferedPartner?distributor.PrefferedPartner.mobile:'-'}}</span>
                                                    </div>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="d-flex">
                                                    <div class="p-icon">
                                                        <i class="material-icons">email</i>
                                                    </div>
                                                    <div class="p-text ml-4">
                                                        {{distributor.PrefferedPartner?toLower(distributor.PrefferedPartner.email):'-'}}
                                                    </div>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                    <!--                                <div class="preffer-person">-->
                                    <!--                                    VAP-->
                                    <!--                                </div>-->
                                </div>

                                <div class="d-flex " style="background: #fff;"
                                     v-if="preferredDistributorsList.length===0">
                                    <div class="preffer-icon my-auto">
                                        <img alt="" class="w-100" src="../../assets/user3.png">
                                    </div>
                                    <div class="preffer-info">
                                        <ul>
                                            <!--<img alt="" src="../../../src/assets/error.png" style="width: 100%">-->
                                            <span style="font-size: 16px; text-align: center; display: block">No Preferred Distributor</span>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <div class="col-4 q-pa-md pl-0 pr-0">
                <div class="p-box position-relative p-4 bankDetails overflow-hidden">
                    <!--<div class="box position-relative p-4 bankDetails overflow-hidden">-->
                    <div class="w-100">
                        <img alt="" class="d-block mx-auto" src="../../../src/assets/card.png">
                    </div>
                    <ul style="list-style: none">
                        <li>
                            <div class="bankLabel">
                                <label for="">Bank Name</label>
                            </div>
                            <div class="acInfo">
                                <span>{{profile.bankDetails[0].bankName}}</span>
                            </div>
                        </li>
                        <li>
                            <div class="bankLabel">
                                <label for="">IFSC</label>
                            </div>
                            <div class="acInfo">
                                <span>{{profile.bankDetails[0].ifsc}}</span>
                            </div>
                        </li>
                        <li>
                            <div class="bankLabel">
                                <label for="">A/C No</label>
                            </div>
                            <div class="acInfo">
                                <span>{{profile.bankDetails[0].accountNumber}}</span>
                            </div>
                        </li>
                        <li>
                            <div class="bankLabel">
                                <label for="">A/C Name</label>
                            </div>
                            <div class="acInfo">
                                <span>{{profile.bankDetails[0].accountName}}</span>
                            </div>
                        </li>
                        <li class="d-flex justify-content-between">
                            <div>
                                <div class="bankLabel">
                                    <label for="">Branch</label>
                                </div>
                                <div class="acInfo">
                                    <span>{{profile.bankDetails[0].branch}}</span>
                                </div>
                            </div>

                            <div style="width: 50%;">
                                <div class="bankLabel">
                                    <label for="">PAN</label>
                                </div>
                                <div class="acInfo">
                                    <span>{{profile.PAN}}</span>
                                </div>
                            </div>
                        </li>
                        <li class="d-flex justify-content-between">
                            <div>
                                <div class="bankLabel">
                                    <label for="">A/C Type</label>
                                </div>
                                <div class="acInfo">
                                    <span>{{profile.bankDetails[0].acountType?profile.bankDetails[0].acountType:'-'}}</span>
                                </div>
                            </div>

                            <div style="width: 50%;" v-if="profile.partnerType === Constants.RP">
                                <div class="bankLabel">
                                    <label for="">Aadhaar</label>
                                </div>
                                <div class="acInfo">
                                    <span>{{profile.aadhaarNumber}}</span>
                                </div>
                            </div>
                            <div style="width: 50%;" v-else>
                                <div class="bankLabel">
                                    <label for="">GSTIN</label>
                                </div>
                                <div class="acInfo">
                                    <span>{{profile.gstin}}</span>
                                </div>
                            </div>
                        </li>
                    </ul>

                    <!--</div>-->
                </div>
            </div>

        </div>
        <q-dialog persistent position="right" v-model="updatePasswordDialog">
            <q-card>
                <div class="row ">
                    <div class="col-6" style="background: #f2f7f4;">
                        <img alt="otp" class="w-100" src="../../assets/otp.png">
                    </div>
                    <div class="col-6 p-2" style="background: #f2f7f4;">
                        <div class="w-100">
                            <q-btn @click="updatePasswordDialog=false" class="float-right" color="primary" dense flat
                                   icon="close">
                                <q-tooltip>Close</q-tooltip>
                            </q-btn>
                        </div>

                        <div><h5>Update Password</h5></div>
                        <div class="py-2 mt-3 mb-3">
                            <h6 style="font-size: 16px;"></h6>
                        </div>
                        <div>
                            <q-form ref="form">
                                <q-input :rules="[val=>val && val.length>0 || 'Please enter Old Password']" class="mb-3"
                                         label="Old Password" type="password"
                                         v-model="oldPassword"></q-input>
                                <q-input :rules="[val=>val && val.length>0 || 'Please enter New Password']" class="mb-3"
                                         label="New Password" type="password"
                                         v-model="newPassword"></q-input>
                                <q-input :rules="[val=>val && val.length>0 || 'Please enter confirm Password']"
                                         class="mb-3" label="Confirm Password" type="password"
                                         v-model="confirmPassword"></q-input>
                                <!--||val===this.newPassword||'Confirm password not matched with new password']"></q-input>-->

                                <q-btn @click="handleSubmit" class="pd-btn my-3 mr-2" size="12px">Update</q-btn>
                                <q-spinner :thickness="2" color="green" size="2em" v-if="loading3"></q-spinner>
                            </q-form>
                        </div>


                    </div>
                </div>
            </q-card>
        </q-dialog>
    </div>
</template>

<script>
  import { GET_ORG_BY_ID } from '../../graphql/queries/organization'
  import { GET_PREFERRED_DISTRIBUTORS_FOR_RD } from '../../graphql/queries/Users'
  import moment from 'moment'
  import { UPDATE_PROFILE_PIC } from '../../graphql/mutations/user'
  import { NetworkCommunicator, setHeader } from '../../plugins/NetworkResourceHandler'
  import Constants from '../../Constants/Constant'
  import { LightGallery } from 'vue-light-gallery'
  import VueCropper from 'vue-cropperjs'
  import 'cropperjs/dist/cropper.css'
  import Avatar from 'vue-avatar'

  export default {
    name: 'Profile',
    components: { LightGallery, VueCropper, Avatar },
    apollo: {
      Organizations: {
        query: GET_ORG_BY_ID,
        fetchPolicy: 'network-only',
        variables () {
          return {
            id: JSON.parse(localStorage.getItem('user')).orgId,
          }
        },
        result ({ data, loading }) {
          if (!loading) {
            this.profile = data.Organizations[0]
            // this.imgSrc = Constants.base_url
            // if (data.Users[0].profile) {
            //   this.imgSrc = Constants.base_url + data.Users[0].profile
            //   this.imgSrc2 = Constants.base_url + data.Users[0].profile
            // }
            if (this.profile.PreferredDistributors && this.profile.PreferredDistributors.length) {
              this.preferredDistributorsList = JSON.parse(JSON.stringify(this.profile.PreferredDistributors))
            } else {
              this.fetchAIPL()
            }
            // this.user = data.Users[0]
          }
        },
      },
    },
    methods: {
      async fetchAIPL () {
        this.preferredDistributorsList = []
        let response = await this.$apollo.query({
          fetchPolicy: 'network-only',
          query: GET_PREFERRED_DISTRIBUTORS_FOR_RD,
        })
        this.preferredDistributorsList = [{ PrefferedPartner: null }]
        this.preferredDistributorsList[0].PrefferedPartner = response.data.preferredDistributorsForRD[0]
      },
      dateFilter (val) {
        return val ? moment(val).format('DD/MM/YYYY') : '-'
      },
      getVisitingCard () {
        NetworkCommunicator('GET', `${Constants.api_url}getImage/` + this.user.orgId).then(res => {
            if (res.flag)
              this.visitingCardUrl = res.data
            // else
            //   alert(res.message)
          },
        )
      },
      viewImage (imageUrl, index) {
        this.fullScreenImageArr = []
        this.imageIndex = index
        this.fullScreenImageArr.push({ url: imageUrl, title: '' })
        this.fullScreenImageDialog = true
      },
      openUpdatePasswordDialog () {
        this.oldPassword = ''
        this.newPassword = ''
        this.confirmPassword = ''
        this.updatePasswordDialog = true
      },
      handleSubmit () {
        var self = this
        this.$refs['form'].validate().then(success => {
          if (success) {self.updatePassword()}
        })
      },
      async updatePassword () {
        if (this.newPassword !== this.confirmPassword) {
          this.$q.notify('New password entered not matched with confirm password')
          return
        }

        this.loading3 = true
        let response = await NetworkCommunicator('POST', `${Constants.api_url}changePassword`,
          false, { oldPassword: this.oldPassword, newPassword: this.newPassword }, {})
        this.loading3 = false
        if (response.flag) {
          this.updatePasswordDialog = false
          this.$q.notify(response.message)
        } else {
          this.$q.notify(response.message)
        }
      },
      clickFile () {
        document.getElementById('file').click()
      },
      resetImage () {
        if (!this.imgSrc) {
          this.imgSrc = '../../assets/user-icon.jpg'
        }
        // this.imgSrc = ''
        this.profileDialog = true
      },
      setImage (e) {
        let self = this
        const file = e.target.files[0]
        if (!file.type.includes('image/')) {
          alert('Please select an image file')
          return
        }
        this.file.type = file.type
        this.file.name = file.name
        if (typeof FileReader === 'function') {
          const reader = new FileReader()
          reader.onload = (event) => {
            self.imgSrc = event.target.result
            if (self.$refs.cropper != undefined) {
              self.$refs.cropper.replace(event.target.result)
            }
          }
          reader.readAsDataURL(file)
        } else {
          alert('Sorry, FileReader API not supported')
        }
      },
      uploadImage: function () {
        let self = this
        if (!self.imgSrc) {
          self.$q.notify('Please select image.')
          return
        }
        var croppedImage = self.$refs.cropper.getCroppedCanvas().toDataURL(self.file.type)
        fetch(croppedImage).then(res => res.blob()).then(blob => {
          const file = new File([blob], self.file.name)
          self.updateProfilePic(file)
        })

      },
      updateProfilePic (file) {
        let self = this
        let form = new FormData()
        form.append('doc[]', file, 'profile.jpg')
        NetworkCommunicator('POST', Constants.api_url + 'upload', false, form).then(response => {
          if (response.flag) {
            self.imgSrc = ''
            self.imgSrc2 = response.data.success[0].url
            let request = {
              id: self.user.id,
              profile: response.data.success[0].path,
            }
            self.$apollo.mutate({
              mutation: UPDATE_PROFILE_PIC,
              variables: request,
            })
            self.$q.notify('Profile Updated Successfully')
            self.profileDialog = false
            self.$forceUpdate()
          } else {
            self.$q.notify(response.data.message)
          }
        }).catch(error => {
        })
      },
      removeImage () {
        let self = this
        let request = {
          id: self.user.id,
          profile: null,
        }
        self.$apollo.mutate({
          mutation: UPDATE_PROFILE_PIC,
          variables: request,
        })
        self.$q.notify('Profile Updated Successfully')
      },
    },
    mounted () {
      this.getVisitingCard()
      setHeader()
    },
    data () {
      return {
        Constants: Constants,
        profile: {},
        user: JSON.parse(localStorage.getItem('user')),
        visitingCardUrl: '',
        fullScreenImageDialog: false,
        imageIndex: 0,
        fullScreenImageArr: [],
        preferredDistributorsList: [],
        updatePasswordDialog: false,
        oldPassword: '',
        newPassword: '',
        confirmPassword: '',
        loading3: false,
        profileDialog: false,
        imgSrc: '',
        imgSrc2: '',
        tempImage: require('../../assets/user-icon.jpg'),
        file: { name: '', type: '' },
      }
    },
  }
</script>

<style lang="stylus" scoped>
    .my-card
        width 100%
        max-width 720px
</style>
